<h2 mat-dialog-title>{{ 'scheduler.setup.resource.add-assignment.title' | translate }}</h2>

<form (ngSubmit)="submit()" [formGroup]="assignmentForm">
    <mat-dialog-content class="fullscreen-dialog">
        <!-- Display resource information (non-editable) -->
        <div class="resource-profile">
            <div class="profile-image">
                <img alt="Resource profile picture" src="{{data.resource.imageUrl || 'assets/profile.png'}}" />
            </div>
            <span class="resource-name">{{ data.resource.name }}</span>
        </div>

        <div class="form-fields-container">
            <!-- Roster Selection Dropdown -->
            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Roster*</mat-label>
                <mat-select formControlName="roster">
                    @for (roster of rosters; track roster) {
                    <mat-option [value]="roster">{{ roster.name }}</mat-option>
                    }
                </mat-select>
                @if (isLoadingRosters) {
                <mat-progress-spinner diameter="20" mode="indeterminate" matSuffix></mat-progress-spinner>
                }
            </mat-form-field>

            <!-- Subdivision Selection Dropdown -->
            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Division*</mat-label>
                <mat-select formControlName="subDivision" [disabled]="!assignmentForm.get('roster').value">
                    @for (division of subdivisions; track division) {
                    <mat-option [value]="division">{{ division.name }}</mat-option>
                    }
                </mat-select>
                @if (isLoadingSubdivisions) {
                <mat-progress-spinner diameter="20" mode="indeterminate" matSuffix></mat-progress-spinner>
                }
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Start Date*</mat-label>
                <input [matDatepicker]="startPicker" formControlName="startDate" matInput
                    aria-label="Start date input field" placeholder="DD/MM/YYYY">
                <mat-datepicker-toggle [for]="startPicker" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
                <mat-label>End Date</mat-label>
                <input [matDatepicker]="endPicker" formControlName="endDate" matInput
                       aria-label="End date input field" placeholder="DD/MM/YYYY">
                <mat-datepicker-toggle [for]="endPicker" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button (click)="cancel()" mat-button type="button">Cancel</button>
        <span class="spacer"></span>
        <button [disabled]="!assignmentForm.valid" color="primary" mat-raised-button type="submit">Save</button>
    </mat-dialog-actions>
</form>
